var FormatFactory = require('../../../../factory/formats');
var UserInfoFactory = require('../../../../factory/user-info');
var EditorFacade = require('../../../../facade/editor/editor');
var DesignFacade = require('../../../../facade/design/design');
var FileView = require('../file/view');
import { constants as config } from '@config';
import { logInfo } from 'src/utils/logger';

module.exports = Backbone.View.extend({
  orderPrintPopupWidth: 460,
  toolPanelWidth: 398,
  canvasLeftMargin: 25,

  initialize: function () {
    _.bindAll(this, 'show', 'hide', 'open', 'close', 'getOrderPrintData', 'forceDownload',
      'imageQualityCheck', 'replaceImage');
    var tool = INKIVE.Tool.getInstance();
    var $panel = $('<panel id="order-print-panel">');

    $panel.html('<div class="order-print" aurelia-app="print/main"></div>');
    $('#content').append($panel);

    this.canvas = tool.editor.canvas;
    this.$workArea = $('#workarea, #svgcontent>.main, #ik-grid-snap');
    this.$el = $('#order-print-panel');

    if (!INKIVE.C.IS_MOBILE) {
      INKIVE.Helpers.getStripeScript();
    }
  },

  show: function () {
    var $panel = this.$el;

    EditorFacade.handle('printing', 'toggle_bleed', { show: false });
    this.imageQualityCheck({show: false});
    this.open();
    INKIVE.C.IS_MOBILE || INKIVE.Modal.loader($panel);

    UserInfoFactory.get().then(_.bind(function (user) {
      var data = this.getOrderPrintData(user);

      INKIVE.C.IS_MOBILE
        ? EditorFacade.trigger('printing.opened', data)
        : INKIVE.Helpers.getAureliaLibraries(this.$el.find('[aurelia-app="print/main"]'))
          .then(function () {
            EditorFacade.trigger('printing.opened', data);
            INKIVE.Modal.loaderClose($panel);
          });
    }, this));
  },

  hide: function () {
    EditorFacade.handle('printing', 'toggle_bleed', { show: false });
    this.imageQualityCheck({ show: false });
    this.replaceImage({ show: false });
    this.close();
  },

  open: function () {

    (function waitForPagesPanel (_this) {
      _this.$workArea.css('pointer-events', 'none');
      $('#svgcontent, body').addClass('order-print-active');
      if (INKIVE.C.IS_MOBILE) {
        return;
      }
      INKIVE.Modal.loader(_this.$el);

      if (INKIVE.Menus.pagesPanel) {
        const $pagesPanel = $('#pages-panel .pages-panel');
        const $toolPanel = $('#tool-panel');
        const $canvasPanel = $('#canvas-panel');
        const $popupmenuPanel = $('#element-popupmenu');
        const allPanels = $('#canvas-panel, #element-popupmenu, #sidebar-resize-button');

        $(document).trigger('sidebarpanel.show');
        _this.canvas.clearSelection();
        _this.canvasPanelLeft = _this.canvasPanelLeft || parseInt($canvasPanel.css('left'));
        const toolPanelNewSize = $toolPanel.find('.tool-menu').outerWidth();

        $toolPanel.addClass('collapsed');
        $pagesPanel.is('.pages-panel-opened') &&
        $pagesPanel.find('.btn-show-pages').trigger('click');
        $toolPanel.css('width', toolPanelNewSize).css('opacity', 1);
        allPanels.css('left', toolPanelNewSize);
        $canvasPanel.css('width', '').css('left', toolPanelNewSize);
        $canvasPanel.css('right', _this.orderPrintPopupWidth);
        $popupmenuPanel.css('width', '');
        _this.togglePagesPanel(true);

        $('[data-action=order-print]').addClass('order-print-shown');
        _this.$el.css('width', _this.orderPrintPopupWidth).children().show();
        $popupmenuPanel.find('ul').hide();
        _.delay(() => {
          EditorFacade.handle('zoom', 'fit');
        }, 500);
      } else {
        setTimeout(() => waitForPagesPanel(_this), 500);
      }
    })(this);
  },

  close: function (opts) {
    var $popupmenuPanel = $('#element-popupmenu');
    var $button = $('[data-action=order-print]');

    if (!INKIVE.C.IS_MOBILE) {
      this.togglePagesPanel(false);
      this.$el.css('width', 0).children().hide();
      $('#tool-panel').css('width', this.toolPanelWidth).css('opacity', '').removeClass('collapsed');
      $('#sidebar-resize-button').css('left', this.toolPanelWidth);
      $('#element-popupmenu, #pages-panel').css('left', '');
      $('#canvas-panel').css('left', '').css('right', '');
      $popupmenuPanel.css('width', '');

      $button.removeClass('order-print-shown').removeClass('active');
      $button.addClass('disabled')
        .delay(500)
        .queue(function () {
          $(this).removeClass('disabled');
          $(this).dequeue();
        });
    }

    $('#svgcontent, body').removeClass('order-print-active');
    if (!opts || !opts.replaceImage) {
      this.$workArea.css('pointer-events', '');
      INKIVE.Tool.enableUI();
      INKIVE.C.IS_MOBILE || $popupmenuPanel.find('ul').show();
    }
    _.delay(() => {
      EditorFacade.handle('zoom', 'fit');
    }, 500);
  },

  togglePagesPanel: function (show) {
    if (show) {
      INKIVE.Menus.pagesPanel.setPagesOpen();
      INKIVE.Menus.pagesPanel.showCustomZoom();
    } else {
      INKIVE.Menus.pagesPanel.setPagesClosed();
      INKIVE.Menus.pagesPanel.hideCustomZoom();
    }
  },

  getOrderPrintData: function (user) {
    var pageData = EditorFacade.get('page');
    var getUserData = function (type) {
      var data = user.details.filter(detail => { return detail.type === type; });
      return data.length ? data[0].content : '';
    };

    return {
      apiKey: CONFIG && CONFIG['api_key'],
      width: this.canvas.contentW,
      height: this.canvas.contentH,
      units: FormatFactory.getCurrentSize().unit,
      bleed: this.canvas.runExtensions('getBleedValues'),
      user: {
        name: getUserData('first_name'),
        email: user.email,
        countryId: getUserData('country_code')
      },
      design: {
        currentPage: pageData.current,
        totalPages: pageData.total,
        designId: pageData.id,
        projectId: INKIVE.C.BOOK.id
      }
    };
  },

  forceDownload: function (data) {
    data = data || {};
    const book = INKIVE.C.BOOK || {};
    logInfo('Print Bleed Info: orderPrint -> forceDownload() initial data', { data, book });

    var startPage = data['startPage'] || 1;
    var endPage = data['endPage'] || INKIVE.C.BOOK.num_pages;
    var alert = INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_bold', {
      message: 'modal.alert.preparing_file'
    }), {
      skip: false,
      loader: true
    });

    var opts = {
      baseUrl: INKIVE.C.BASE_URL,
      staticUrl: INKIVE.C.STATIC_URL,
      getUrlResponse: !INKIVE.C.IS_MOBILE
    };

    var params = {
      as_format: data.format || 'pdf',
      book_id: INKIVE.C.BOOK.id,
      is_transparent: 'n',
      bleed: 'y',
      bleed_type: data.bleed_type || 'manual',
      bleed_unit: INKIVE.C.BLEED_VALUES.bleedUnit || 'px',
      cutmarks: 'n',
      is_zip: 'false',
      is_cmyk: 'y',
      has_filter: 'n',
      quality: 'print',
      start_page: startPage,
      end_page: endPage,
      pages: Array.from({ length: endPage - startPage + 1 }, (_, i) => i + startPage),
      width: this.canvas.contentW,
      height: this.canvas.contentH,
      is_outline: data.is_outline || 'n'
    };

    if (data.bleed_type !== 'auto') {
      params.bleed_amount = INKIVE.C.BLEED_VALUES.bleedSize;
      params.slug_unit = params.bleed_unit;
      params.slug_amount = this.canvas.runExtensions('getSlugValues');
    }

    if (data.is_print_order) {
      const defaultBleeds = this.canvas.runExtensions('getDefaultBleedValues');

      params.bleed_type = 'manual';
      params.slug_unit = params.bleed_unit;
      params.bleed_amount = this.canvas.runExtensions('setPrintBleed', { size: defaultBleeds[params.bleed_unit] });

      if (params.bleed_unit === 'in') {
        params.bleed_amount = this.canvas.runExtensions('setPrintBleed', { size: defaultBleeds.in_us });
      }

      params.slug_amount = params.bleed_amount;
    }

    logInfo('Print Bleed Info: orderPrint -> forceDownload() final data', { data, params, book });
    INKIVE.EditorFacade.handle('page', 'save').then(() => {
      INKIVE.EditorFacade.handle('printing', 'toggle_bleed', { show: true });
      INKIVE.Helpers.DownloadProcedure.download((url) => {
        INKIVE.EditorFacade.handle('printing', 'toggle_bleed', { show: false });
        EditorFacade.trigger('printing.force_download.response', url);
        data['skip_download'] || INKIVE.Helpers.saveToDisk(url);
        alert.close();
      }, opts, params);
    }, () => {
      alert.close();
    });
  },

  imageQualityCheck: function (opts) {
    var show = opts.show;
    var imagesChecked = [];
    var totalImages = 0;

    this.currentState = show ? 'imageQualityCheck' : '';
    DesignFacade.off('image.check_quality.end', storeImageQuality);
    this.canvas.runExtensions('removeImageQualityBox');

    if (show) {
      totalImages = FileView.prototype.imgqualityEvent({ skipAdvice: true });

      totalImages
        ? DesignFacade.on('image.check_quality.end', storeImageQuality)
        : EditorFacade.trigger('printing.images_quality_checked', imagesChecked);
    }

    function storeImageQuality (image) {
      imagesChecked.push(image);

      if (imagesChecked.length === totalImages) {
        EditorFacade.trigger('printing.images_quality_checked', imagesChecked);

        imagesChecked = [];
        DesignFacade.off('image.check_quality.end', storeImageQuality);
        INKIVE.C.IS_MOBILE && $('.image-quality-box').on('touchend', _.bind(function (event) {
          var $target = $(event.currentTarget);

          this.canvas.runExtensions('removeImageQualityBox', {});
          EditorFacade.trigger('printing.image-quality.selected', {
            id: $target.attr('data-id'),
            high_quality: $target.is('.high-quality')
          });
        }, this));
      }
    }
  },

  replaceImage: function (opts) {
    var hideReplaceImage = _.bind(_hideReplaceImage, this);
    var doReplaceImage = _.bind(_doReplaceImage, this);

    if (!opts || !opts.id || this.currentState !== 'imageQualityCheck') {
      hideReplaceImage();
      return;
    }

    var imageId = opts.id === 'background' ? config.background.image : opts.id;
    var $selected = $('#' + imageId);

    if (!$selected.length) {
      return;
    }

    var $cancelButton = $('<ul style=""><li><a class="btn btn-onmenu action" id="printing-replaceimg-cancel">' +
      '<i class="icon-deselect"></a></li></ul>');
    var $toolPanel = $('#tool-panel');
    var isBackground = $selected.parent().is('.background');

    $('.root-popupmenu').find('.special-buttons').append($cancelButton.on('click', hideReplaceImage));
    this.imageQualityCheck({ show: false });
    this.canvas.setMode('replace-' + (isBackground ? 'background' : 'image'));
    this.canvas.selectOnly($selected);
    this.close({ replaceImage: true });
    this.currentState = 'replaceImage';

    $toolPanel.find('[href=#tabImages]').click();
    $toolPanel.find('.tool-menu').addClass('disabled');
    $toolPanel.removeClass('disabled');

    DesignFacade.once(isBackground ? 'background.update.updating_source' : 'image.update.source.url', function () {
      $toolPanel.addClass('disabled');
    });

    this.isImageCrop = true;
    EditorFacade.once('history.change', doReplaceImage);

    function _doReplaceImage () {
      if (this.currentState !== 'replaceImage') {
        return;
      }

      var element = isBackground ? 'background' : 'image';

      this.canvas.setMode('select');
      this.$workArea.css('pointer-events', '');

      _.delay(function () {
        $('[data-action=on_layoutConfirm]').parent().siblings().remove();
        $('#element-popupmenu').find('ul').show();
      }, 200);

      EditorFacade.once(element + '.crop.end', _.partial(hideReplaceImage, true));

      _.delay(function () {
        EditorFacade.handle(imageId, 'crop');
      }, 500);
    }

    function _hideReplaceImage (isCropEnd) {
      $('#printing-replaceimg-cancel').remove();

      if (isCropEnd) {
        this.isImageCrop = false;
      }

      if (this.currentState !== 'replaceImage' || this.isImageCrop) {
        return;
      }

      this.open({ replaceImage: true });
      _.delay(_.bind(this.imageQualityCheck, this, { show: true }), 500);
    }
  }
});
